import React, { ReactNode } from 'react';
import styled, { CSSProperties } from 'styled-components';
import { Col, Row, Button } from 'src/antd';
import { RightOutlined } from '@ant-design/icons';
import { createPrefixer } from 'src/utils';

const p = createPrefixer('wh-custom-button-');

const classes = {
  arrowOutlined: p`arrow-outlined`,
  icon: p`icon`,
  title: p`title`,
  mainContent: p`main-content`,
  iconAndTitleWrapper: p`icon-and-title-wrapper`,
};

export type CustomButtonProps = {
  style?: CSSProperties;
  icon: ReactNode;
  title: string | ReactNode;
  onClick: () => void;
};

const CustomButtonDiv = styled.div`
  width: 100%;

  .ant-btn {
    width: inherit !important;
    height: auto !important;
    padding: 0 !important;
    background: ${(props) => props.theme.colors.dark5};
    border: none;
    white-space: normal;
    border-radius: 8px !important;
  }

  .ant-btn:not([disabled]):hover {
    background: ${(props) => props.theme.colors.dark100};

    .${classes.arrowOutlined} {
      color: ${(props) => props.theme.colors.light100};
    }

    .${classes.icon} {
      color: ${(props) => props.theme.colors.light100};
    }

    .${classes.title} {
      color: ${(props) => props.theme.colors.light100};
    }
  }

  .${classes.iconAndTitleWrapper} {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .${classes.arrowOutlined} {
    display: none;
  }

  .${classes.icon} {
    font-size: 3.313rem;
    color: ${(props) => props.theme.colors.dark100};
  }

  .${classes.title} {
    font-size: 1rem;
    font-weight: 600;
    color: ${(props) => props.theme.colors.dark100};
  }

  .${classes.mainContent} {
    width: 100%;
    padding: 1rem 2rem;
  }

  @media screen and (min-width: 992px) {
    width: calc(100%);

    .ant-btn {
      width: inherit !important;
    }

    .${classes.iconAndTitleWrapper} {
      align-items: center;
      justify-content: start;
      flex-direction: row;
    }

    .${classes.arrowOutlined} {
      font-size: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${(props) => props.theme.colors.dark20};
    }

    .${classes.icon} {
      font-size: 1.313rem;
      margin-right: 1rem;
    }

    .${classes.title} {
      font-size: 1.25rem;
    }

    .${classes.mainContent} {
      padding: 1.5rem;
    }
  }
`;

const CustomButton: React.FC<CustomButtonProps> = ({
  icon,
  title,
  onClick,
  style,
}) => {
  return (
    <CustomButtonDiv style={style}>
      <Button onClick={onClick}>
        <Row>
          <Col md={24} lg={22} className={classes.mainContent}>
            <Row>
              <Col span={24}>
                <div className={classes.iconAndTitleWrapper}>
                  <div className={classes.icon}>{icon}</div>
                  <div className={classes.title}>{title}</div>
                </div>
              </Col>
            </Row>
          </Col>
          <Col md={0} lg={2} className={classes.arrowOutlined}>
            <RightOutlined style={{ fontSize: 'inherit' }} />
          </Col>
        </Row>
      </Button>
    </CustomButtonDiv>
  );
};

export default CustomButton;
